import Axios from 'axios';
import {useState, useEffect} from 'react';
import { Carousel } from 'react-bootstrap';
import {getApiSpotlights} from 'api/data/cms';

import './index.css';

// demo過後會安排時間串API 由後台控制圖片
import img from 'img/carousel/banner@3x.webp';
import img2 from 'img/carousel/banner2.jpeg';
import img3 from 'img/carousel/banner@3x.webp';
import img4 from 'img/carousel/banner2.jpeg';

const CarouselDefault = () => {
  const addImg = [
    {key: 0, img: img},
    {key: 1, img: img2},
    {key: 2, img: img3},
    {key: 3, img: img4}
  ]

  // 串接平台API
  // const [addImg, setAddImg] = useState({result:[]})
  // useEffect(async() => {
  //     const res = await getApiSpotlights();
  //     setAddImg(res);
  //     console.log('get Carousel:', res)
  // },[])

//   <Carousel fade interval={3000} className="carouselWrap">
//   {addImg.result.map(item => <Carousel.Item key={item.objectID}>
//     <img
//       className="w-100"
//       src={item.picture}
//       alt={item.title}
//     /></Carousel.Item> )}
// </Carousel>

  return(
    <>
<Carousel fade interval={3000} className="carouselWrap">
  {addImg.map(({key, img}) => <Carousel.Item key={key}>
    <img
      className="w-100"
      src={img}
      alt=""
    /></Carousel.Item> )}
</Carousel>
  </>
  )
}

export default CarouselDefault;

